import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { StorageNamespace } from '@/helpers/storage-namespaces';

let searchResultStorage: StorageHelper | null = null;

export function getSearchResultStorage(): StorageHelper {
  if (!searchResultStorage) {
    searchResultStorage = new StorageHelper(StorageNamespace.searchResults);
  }

  return searchResultStorage;
}
